export default __webpack_public_path__ + "static/media/video_icon.03b79ccb.webp";